import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import {TasksJobConfirmComponent} from './tasks-job-confirm.component';
import { SharedModule } from '../../../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    SharedModule
  ],
  declarations: [TasksJobConfirmComponent],
  exports: [TasksJobConfirmComponent]
})
export class TasksJobConfirmModule {}
